import styled from "styled-components";

export default styled.div`
  margin-top: ${({ theme }) => theme.margin.large};
  margin-left: ${({ theme }) => theme.margin.large};
`;
